import React from "react";
import "../style/FooterTabComponent.css"
import {
  FaTwitter,
  FaFacebookF,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaLinkedin
} from "react-icons/fa";

const FooterTabComponent = () => {
  return (
    
    <footer className="footer-wrapper">
      <div className="footer-top">
        <div className="footer-section">
          <h4>About Us</h4>
          <ul>
            <li><a href="https://www.fipi.org.in/history.php">History</a></li>
            
            <li><a href="https://www.fipi.org.in/we-represent.php">We Represent</a></li>
            <li><a href="https://www.fipi.org.in/vision.php">Vision</a></li>
            <li><a href="https://www.fipi.org.in/governing-council-members.php">Governing Council Members</a></li>
            <li><a href="https://www.fipi.org.in/governing-council-meetings.php">Governing Council Meeting</a></li>
            <li><a href="https://www.fipi.org.in/leadership-team.php">Leadership Team</a></li>
            <li><a href="https://www.fipi.org.in/contact-us.php">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Quick Access</h4>
          <ul>
            <li><a href="https://www.fipi.org.in/members.php">Members</a></li>
            <li><a href="https://www.fipi.org.in/in-news1.php">FIPI Speaks</a></li>
            <li><a href="https://award.fipi.org.in/fipiawards/">Awards 2024-25</a></li>
            <li><a href="https://www.fipi.org.in/recommendations.php">Recommendations</a></li>
            <li><a href="https://www.fipi.org.in/committees-meetings.php"> Meetings</a></li>
            <li><a href="https://www.fipi.org.in/events.php">Past Events</a></li>
            <li><a href="https://www.fipi.org.in/upcoming-events.php"> Upcoming Events</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Company</h4>
          <address>
            J-105, Tower-J, First Floor,<br />
            World Trade Centre,<br />
            Nauroji Nagar,<br />
            New Delhi-110029
          </address>
          <p><FaEnvelope /> dg.sectt@fipi.org.in</p>

          <p><FaPhone /> +91-11-40886000</p>
        </div>

        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <FaTwitter 
            onClick={() =>
            window.open("https://x.com/fipiind", "_blank")
          }/>
            <FaFacebookF 
            onClick={() =>
            window.open("https://www.facebook.com/fipiind/", "_blank")
          }/>
          {/* <FaLinkedin
            onClick={() =>
            window.open("https://in.linkedin.com/company/federation-of-indian-petroleum-industry", "_blank")
          }
          /> */}
            <FaYoutube 
           onClick={() =>
            window.open("https://www.youtube.com/channel/UCbmocFLn4uZJCsQQNU_FfJQ", "_blank")
          }/>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-links">
          <a href="https://fipi.org.in/sitemap.php">Sitemap</a>
          <a href="https://fipi.org.in/term-of-use.php">Terms of use</a>
          <a href="https://fipi.org.in/privacy-policy.php">Privacy Policy</a>
          <a href="https://fipi.org.in/refund-and-cancellation.php">Refund Policy</a>
        </div>
        <p className="copyright">Copyright © {new Date().getFullYear()} FIPI</p>
      </div>
    </footer>
  );
};

export default FooterTabComponent;